import useTranslation from 'next-translate/useTranslation';
import Caption, { VARIANT as CAPTION_VARIANT } from '@/components/Caption';
import { Comment as PostCommentsModel } from '@/models/Posts';
import SubHeading, { VARIANT as SUBHEADING_VARIANT } from '../SubHeading';
import Comment from './PostComment';
interface Props {
  id: number;
  comments: PostCommentsModel[];
  loading: boolean;
  loadingNext: boolean;
  nextPageUrl: string | null;
  error: string;
  fetchNext: VoidFunction;
}
const PostCommentsList = ({
  comments,
  loading,
  loadingNext,
  nextPageUrl,
  error,
  fetchNext
}: Props) => {
  const {
    t
  } = useTranslation('posts');
  if (Array.isArray(comments) && comments.length === 0) return <div className="mb-4">
        <SubHeading variant={SUBHEADING_VARIANT.MEDIUM}>
          {t('no_comments_caption')}
        </SubHeading>
      </div>;
  if (loading || loadingNext) return <SubHeading variant={SUBHEADING_VARIANT.SMALL}>
        {t('loading_caption')}
      </SubHeading>;
  return <div data-sentry-component="PostCommentsList" data-sentry-source-file="PostCommentsList.tsx">
      <SubHeading variant={SUBHEADING_VARIANT.MEDIUM} className="mb-8" data-sentry-element="SubHeading" data-sentry-source-file="PostCommentsList.tsx">
        {t('total_comments_caption')}
      </SubHeading>
      {comments.map(item => <Comment key={item.id} {...item} />)}
      {nextPageUrl !== null && <button onClick={fetchNext} data-testid="post-comments-read-more">
          {t('read_more_btn')}
        </button>}
      {error !== '' && <Caption variant={CAPTION_VARIANT.ONE} label={t(error)} className="text-center" />}
    </div>;
};
export default PostCommentsList;